export const GET_INPUTS = {
  REQUEST: "GET_INPUTS",
  PENDING: "GET_INPUTS_PENDING",
  FULFILLED: "GET_INPUTS_FULFILLED",
  FAILED: "GET_INPUTS_FAILED"
}

export const SET_CHECKED_INPUT = 'SET_CHECKED_INPUT'

export const SET_SEARCH = 'SET_INPUTS_SEARCH'